export default {
    getAllProjects: () => {
        return {
            url: '/simulationenr/project',
            method: 'GET'
        };
    },
    getProjectDetails: projectId => {
        return {
            url: '/simulationenr/project/:projectId',
            method: 'GET',
            route_params: {
                projectId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/simulationenr/data/Projects/api.js